import { __rest } from "tslib";
import React from 'react';
import { colors } from '../../theme/modules/colors';
import { Pill, Text, Row, Col, HeaderCol, ChildContainer, IconCol } from './styled';
import { Button } from '../Button';
import { CrossIcon } from '../../tempIcons/CrossIcon';
import { sizes } from '../../theme/modules/sizes';
const accentColors = {
    help: colors.secondary.blue.base,
    info: colors.neutral.ink.base,
    error: colors.secondary.red.base,
    success: colors.secondary.green.base,
};
/**
 * The `Banner` component was previously called `Alert` (and similarly `Pill`).
 */
export const Banner = (_a) => {
    var { type = 'info', text, icon, onClose, className, header, children, backgroundColor = 'white' } = _a, props = __rest(_a, ["type", "text", "icon", "onClose", "className", "header", "children", "backgroundColor"]);
    const accentColor = accentColors[type];
    return (React.createElement(Pill, Object.assign({ accentColor: accentColor, className: className, backgroundColor: backgroundColor }, props),
        React.createElement(Row, null,
            icon && (React.createElement(IconCol, { style: { marginRight: sizes.md }, accentColor: accentColor }, icon)),
            children ? (React.createElement(ChildContainer, null, children)) : (React.createElement(React.Fragment, null,
                React.createElement(HeaderCol, null, header || React.createElement(Text, { variant: "headingSmall" }, text)),
                React.createElement(Col, null, onClose && (React.createElement(Button, { variant: "flat", "aria-label": "Close", icon: React.createElement(CrossIcon, null), onClick: onClose }))))))));
};
//# sourceMappingURL=Banner.js.map